export default "__VITE_ASSET__iryrwZWB__"